import styled from "styled-components";

export const AppWrapper = styled.div`
	position: fixed;
	width: 100%;
	height: 100%;
	z-index: ${props => (props.mobileApp ? 999998 : 2147483640)};
	top: 0;

	background: ${props => props.theme.white};
`;
